<template>

  <v-container fluid class="pa-0">

    <v-layout>

      <v-flex xs6 v-for="(card, index) in useCategories" :key="index">

        <v-expand-transition>
          <v-sheet class="d-flex flex-column justify-center ma-1 white--text card-hover"
                   tile
                   :min-height="cardHeight"
                   @click="selectUseCategory(card)"
          >

            <!--            <img :src="`${$publicPath}${card.bgImage}`" alt="ss" v-if="card.bgImage">-->

            <v-img :src="`${$publicPath}${card.bgImage}`" height="250"
                   :gradient="card.gradient"
            >

              <h4 class="d-flex fill-height display-1 align-center justify-center">
                <v-icon large left color="white">{{card.mdIcon}}</v-icon>
                {{card.text}}
              </h4>

            </v-img>

          </v-sheet>

        </v-expand-transition>

      </v-flex>

    </v-layout>

  </v-container>

</template>

<script>

export default {

  name: 'Wizard.UseCategory',

  props: {},

  data() {
    return {
      hover: false,
    };
  },

  mounted() {
    if (!this.$store.state.wizard.preferences.useCategory.value) {
      this.$store.dispatch('setPreferences', {
        ...this.$store.state.wizard.preferences,
        useCategory: this.useCategories[0],
      });
    }
  },

  computed: {

    step() {
      return this.$route.query.step;
    },


    cardHeight() {
      return (this.step > 1 || this.$route.name === 'wizard-offerings') ? 60 : 160;
    },

    useCategories() {
      return this.$store.getters.models.useCategories;
    },

    category() {
      return this.$store.state.wizard.preferences.useCategory.value;
    },

  },

  methods: {

    selectUseCategory(item) {
      this.$store.dispatch('setPreferences', {
        ...this.$store.state.wizard.preferences,
        useCategory: item,
      });

      this.$router.push({
        name: `wizard-${item.value}`,
        query: {
          step: 1,
        }
      });
    },

    cardClasses({ index, card }) {
      return [
        index === 0 ? 'mr-2' : '',
        card.value === this.category ? 'primary elevation-4' : 'grey lighten-3'
      ];
    },

  },

};
</script>
